import { SupplyReviews } from './../../models/supply-reviews';
import { ToastService } from './../../../../core/toast.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddSupplyReviewsService } from '../../services/add-supply-reviews.service';

@Component({
  selector: 'app-rating-remark',
  templateUrl: './rating-remark.component.html',
  styleUrls: ['./rating-remark.component.scss']
})
export class RatingRemarkComponent implements OnInit {
  ratingReviewForm = this.fb.group({
    supply_id : [null, []],
    supply_variant_id: [null, []],
    rating: [1, [Validators.required]],
    message: [null, [Validators.required]],
    attachments: [null, [Validators.required]]
  });
  constructor(
    private _dialogRef: MatDialogRef<RatingRemarkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private toast: ToastService,
    private addSupplyReviewsService: AddSupplyReviewsService
  ) { }

  ngOnInit(): void {
    this.supply_id.setValue(this.data.supply_id);
    this.supply_variant_id.setValue(this.data.supply_variant_id);
  }
  dialogClose(status: string) {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
 get supply_id(){
   return this.ratingReviewForm.get('supply_id');
 }

 get supply_variant_id(){
  return this.ratingReviewForm.get('supply_variant_id');
}

get rating(){
  return this.ratingReviewForm.get('rating');
}

get message(){
  return this.ratingReviewForm.get('message');
}

 get attachments(){
   return this.ratingReviewForm.get('attachments');
 }

 async sendRatingAndReview(){
    if(this.ratingReviewForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      this.ratingReviewForm.markAllAsTouched();
      return;
    }
    try {
      const supply_reviews = this.ratingReviewForm.value as SupplyReviews;
      const response = await this.addSupplyReviewsService.addSupplyReviewsOne(supply_reviews);
      this.toast.openSnackBar('Review submitted successfully');
      this.dialogClose('yes');
    } catch(error){
      this.toast.openSnackBar('Unable to submit review');
    }
 }
}

